import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApiService } from "../services/api.service";
import { GoogleAuthService } from "../services/google-auth.service";
import { localStorageService } from "../services/localstorage.service";
import { SocketsService } from "../services/socket.service";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxGpAutocompleteModule } from "@angular-magic/ngx-gp-autocomplete";
import { Loader } from "@googlemaps/js-api-loader";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { LoaderComponent } from "./loader/loader.component";
import { LogoutModalComponent } from "./logout-modal/logout-modal.component";
import { ToasterContainerComponent } from "./toaster/toaster-container-component";
import { ToasterComponent } from "./toaster/toaster.component";
import { ToasterService } from "./toaster/toaster.service";
import { GoogleZipComponent } from "./google-zip/google-zip.component";
import { DateOfBirthComponent } from "./date-of-birth/date-of-birth.component";
import { BsModalService } from "ngx-bootstrap/modal";
// import { LeftLayoutComponent } from "../pages/public/left-layout/left-layout.component";
import { NewPasswordComponent } from "../pages/public/new-password/new-password.component";
import { NoSpacesDirective } from "./no-space.directive";
import { CalendarComponent } from "./calendar/calendar.component";
import { GenerateStripeElementComponent } from "./generate-stripe-element/generate-stripe-element.component";
import { SignaturePadComponent } from "./signature-pad/signature-pad.component";
import { ClipboardModule } from "ngx-clipboard";
import { CustomDateInputComponent } from './custom-date-input/custom-date-input.component';
import { ConfirmationComponent } from "./confirmation/confirmation.component";
import { CurrencyFormatPipe, PhoneMaskPipe, MaskSensitivePipe } from "../services/shared.service";
import { CollectingModalComponent } from './collecting-modal/collecting-modal.component';
import { EnableDebtCollectionComponent } from './enable-debt-collection/enable-debt-collection.component';
import { DebtTypeConfirmationComponent } from './debt-type-confirmation/debt-type-confirmation.component';
import { EConsentModalComponent } from './e-consent-modal/e-consent-modal.component';


@NgModule({
    declarations: [LoaderComponent, ToasterComponent, ToasterContainerComponent, LogoutModalComponent, CalendarComponent, GoogleZipComponent, GenerateStripeElementComponent, SignaturePadComponent, DateOfBirthComponent, NoSpacesDirective, NewPasswordComponent, CustomDateInputComponent, ConfirmationComponent, CurrencyFormatPipe,MaskSensitivePipe,CollectingModalComponent, CurrencyFormatPipe, EnableDebtCollectionComponent, DebtTypeConfirmationComponent, PhoneMaskPipe, EConsentModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
        NgxMaskDirective,
        NgxGpAutocompleteModule,
        NgxMaskPipe,
        PaginationModule.forRoot()
    ],
    providers: [localStorageService, ApiService,ToasterService, GoogleAuthService,SocketsService, BsModalService,
      {
        provide: Loader,
        useValue: new Loader({
          apiKey: window.location.href.includes('.recuvery.com') ? 'AIzaSyDuayE9g_ErYJHUDNwcELxOoaiidjG4E2k' :'AIzaSyAudUxsyfqNreXJdNllGSnMiyWZqdZHF-I',
          libraries: ['places']
        })
      },
      provideNgxMask()],
    exports: [LoaderComponent, ToasterContainerComponent, BsDropdownModule, NgxMaskDirective, NgxMaskPipe, NgxGpAutocompleteModule, CalendarComponent, GoogleZipComponent, ClipboardModule, SignaturePadComponent, PaginationModule, TooltipModule, DateOfBirthComponent, NoSpacesDirective,NewPasswordComponent, FormsModule, ReactiveFormsModule, CustomDateInputComponent, CurrencyFormatPipe,MaskSensitivePipe, PhoneMaskPipe]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}